import React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: React.Node,
};

export const Option = ({ children, ...rest }: Props) => {
  return <StyledOption {...rest}>{children}</StyledOption>;
};

const StyledOption = styled('option')`
  &:disabled {
    color: ${({ theme }) => theme.color.lightGrey};
  }
`;
